import { Component, Input, OnInit } from '@angular/core';

type AcceptedColors =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'info'
  | 'warning'
  | 'danger'
  | 'news';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.css'],
})
export class BadgeComponent implements OnInit {
  @Input() content: string;
  @Input() color: AcceptedColors;

  constructor() {}

  ngOnInit(): void {}
}
